import React from 'react';
import { ActionMenuBadge, IActionMenuBadgeItem } from './action-menu-badge';
import * as S from './action-menu-badge.styles';
import image from './payer.png';
import { generateLabel } from './util';

export interface IPayerIdBadgeProps {
    className?: string;
    id?: string;
    name?: string;
    path?: string;
    tooltip?: string;
    items?: IActionMenuBadgeItem[];
}
export const PayerIdBadge: React.FunctionComponent<IPayerIdBadgeProps> = (
    props: IPayerIdBadgeProps,
): React.ReactElement => {
    const { className, id, name, path, tooltip, items } = props;
    return (
        <ActionMenuBadge
            className={className}
            label={generateLabel('Payer', id, name)}
            path={path || `/payers/${id}`}
            tooltip={tooltip}
            items={items}
            Symbol={<S.ImageSymbol src={image} />}
        />
    );
};
